/*
███╗   ███╗██╗██╗  ██╗██╗███╗   ██╗███████╗
████╗ ████║██║╚██╗██╔╝██║████╗  ██║██╔════╝
██╔████╔██║██║ ╚███╔╝ ██║██╔██╗ ██║███████╗
██║╚██╔╝██║██║ ██╔██╗ ██║██║╚██╗██║╚════██║
██║ ╚═╝ ██║██║██╔╝ ██╗██║██║ ╚████║███████║
╚═╝     ╚═╝╚═╝╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝╚══════╝
*/

import store from './store'
import moment from 'moment'

export default {
    methods: {

        /**
         * Formata uma date ou datetime
         */
        dateFormat (value, datetime) {
            return moment(value).format(datetime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY')
        },

        /**
         * Formata um float para o padrão pt-BR junto com o cifrão R$
         */
        priceFormat (value, decimal = 2) {
            return new Intl.NumberFormat('pt-BR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: decimal,
                style: 'currency',
                currency: 'BRL'
            }).format(value)
        },

        /**
         * Transformar um valor R$ 1,50 para float 1.50
         */
        treatmentPriceToFloat (value) {
            return value.toString().replace(/[^0-9|,]/g, '').replace(',', '.')
        },

        /**
         * Transforma um número de telefone para tipo number (47) 99191-1212 para 47991911212
         */
        treatmentPhoneToNumber (value) {
            return value.replace(/[^0-9]/g, '')
        },

        /**
         * Transforma uma data pt-BR para o formato americano 31/12/2018 para 2018-12-31
         */
        treatmentDateStringToDate (value) {
            return value.split('/').reverse().join('-')
        },

        /**
         * Remover caracteres especiais
         */
        strSlug (strToReplace) {
            let strSChar = 'áàâãäåaaaÁÂÃÄÅAAAÀéèêëeeeeeEEEÉEEÈìíîïìiiiÌÍÎÏÌIIIóôõöoooòÒÓÔÕÖOOOùúûüuuuuÙÚÛÜUUUUçÇñÑýÝ\\´`'
            let strNoSChars = 'aaaaaaaaaAAAAAAAAAeeeeeeeeeEEEEEEEiiiiiiiiIIIIIIIIooooooooOOOOOOOOuuuuuuuuUUUUUUUUcCnNyY/  '
            let newStr = ''

            for (let i = 0; i < strToReplace.length; i++) {
                if (strSChar.indexOf(strToReplace.charAt(i)) !== -1) {
                    newStr += strNoSChars.substr(strSChar.search(strToReplace.substr(i, 1)), 1)
                } else {
                    newStr += strToReplace.substr(i, 1)
                }
            }

            return newStr.replace(/[^a-zA-Z0-9/.:;,+*_$%=\-<>@~^#?!()|[]{}]+/g, '')
        },

        countChars (message) {
            let count = message.length
            if (message.indexOf('#NOME#') !== -1 || message.indexOf('#nome#') !== -1) {
                count = count + 6
            }

            if (message.indexOf('#VAR1#') !== -1 || message.indexOf('#var1#') !== -1) {
                count = count + 6
            }

            if (message.indexOf('#VAR2#') !== -1 || message.indexOf('#var2#') !== -1) {
                count = count + 6
            }

            if (message.indexOf('#VAR3#') !== -1 || message.indexOf('#var3#') !== -1) {
                count = count + 6
            }

            var allChars = message.split('')
            var specialCharts = ['\\', '|', '^', '€', '{', '}', '[', ']', '~']

            allChars.forEach(item => {
                if (specialCharts.includes(item)) {
                    count = count + 1
                }
            })

            return count
        },

        countCredits (message) {
            let total = this.countChars(message)
            if (total > 160) {
                return Math.ceil(total / 150)
            }
            return Math.ceil(total / 160)
        },

        /**
         * Verifica se a empresa salva no state é a Ziad (isProvider)
         */
        isZiad () {
            if (store.state.company) {
                return store.state.company.isProvider || false
            }
            return false
        },

        /**
         * Método retorna a descrição do mês informado
         */
        getMonth (month, abrev = false) {
            let long = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
            let abr = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
            if (abrev) {
                return abr[month - 1]
            }
            return long[month - 1]
        }
    }
}
